module.exports = __webpack_public_path__ + "img/comon.da09395b.png";